// --- (1), (2) & (3): install and import ---
import React from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import "../../App.css"; 
import borders from "./borders.json";
import { useTranslation } from 'react-i18next';




function Map(props) {
  const setColor = ({ properties }) => {
    return { weight: 0.7, color: "darkGreen" };
  };
  const { t } = useTranslation();

  function GeoJSONComponent({ data }) {
    const onEachFeature = (feature, layer) => {
     
      if (feature.properties && feature.properties.maplab) {

        const tooltipContent =  props.data[props.data.findIndex(element => element.substr(0, 3) === feature.properties.iso3cd)].substring(3).replace("-" , ": ") + " " + t('lower_case_species');
  
        layer.on("mouseover", function (e) {
          this.bindTooltip(`${tooltipContent}`, {sticky: "true"})
       
        });
  
      }
    };

    return (
      <GeoJSON
        data={data}
        onEachFeature={onEachFeature}
        style={setColor}
      />
    );
  }
  
var countryArray = props.data.length > 0 ? props.data.map(elem => elem.substr(0, 3)) : [];
 
  return (
    <section className='map-component' >
      {/* --- (5) Add leaflet map container --- */}
      <div className='map'>
      <MapContainer center={[20,0]} zoom={2}  scrollWheelZoom={true} style={{ width: "100%", height: "50vh" }} className="ratio ratio-21x9">
      
        <TileLayer
        attributionPrefix="Leaflet"
          attribution='© UN'
          maxZoom={18}
          minZoom={1}
          url="https://pro-ags1.dfs.un.org/arcgis/rest/services/basemaps/clearmap_webtopo_nolabel_cvw/MapServer/tile/{z}/{y}/{x}"
          //"https://pro-ags1.dfs.un.org/arcgis/rest/services/basemaps/clearmap_webtopo_nolabel_cvw/MapServer/tile/{z}/{y}/{x}"
          
        />

          {countryArray.join("$").length > 0 && borders.features.filter((polygon) => countryArray.join("$").includes(polygon.properties.iso3cd)).map((feature, index) => (
          <GeoJSONComponent key={index} data={feature} />
        ))}
      </MapContainer>
      {/* --- ---------------------------- --- */}
      </div>
    </section>
  )
}
export default Map